export default __webpack_public_path__ + "static/media/Blog2_2.2acda511.jpg";